import * as React from "react";
import Layout from "@components/Layout";
import RecurringIssueScreen from "@screens/RecurringIssues";
import withAuth from "@helpers/withAuth";

const RecurringIssuesPage: React.FC = () => {
  return (
    <Layout active="settings/recurring-issues">
      <RecurringIssueScreen />
    </Layout>
  );
};

export default withAuth(RecurringIssuesPage);
